export const leftArrow = require("../assets/leftArrow.svg");
